export default __webpack_public_path__ + "static/media/Заавар_Хичээл,_сургалтын_үйл_ажиллагаа_2024.51e2a7ac.pptx";